import {
  Greeny,
  Christine,
  Primary,
  SemanticError,
  Warning,
} from '../../../core-components/theme/color-palette/colors';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import dayjs from 'dayjs';

export const getInsightTypeChipStyleAndIcon = (type: string) => {
  const lower = type.toLowerCase();

  switch (lower) {
    case 'improvement':
      return {
        icon: WorkspacePremiumOutlinedIcon,
        borderColor: Greeny[300],
        backgroundColor: Greeny[50],
        textColor: Greeny[900],
      };
    case 'accomplishment':
      return {
        icon: WorkspacePremiumOutlinedIcon,
        borderColor: Greeny[300],
        backgroundColor: Greeny[50],
        textColor: Greeny[900],
      };
    case 'incident':
      return {
        icon: CampaignOutlinedIcon,
        borderColor: SemanticError[900],
        backgroundColor: SemanticError[50],
        textColor: SemanticError[900],
      };
    case 'warning':
      return {
        icon: WarningAmberOutlinedIcon,
        borderColor: Warning[600],
        backgroundColor: Warning[50],
        textColor: Warning[900],
      };
    case 'issue':
      return {
        icon: BugReportOutlinedIcon,
        borderColor: Christine[500],
        backgroundColor: Christine[50],
        textColor: Christine[800],
      };
    default:
      return {
        icon: null,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        textColor: Primary[900],
      };
  }
};

export interface DateRange {
  fromDate: string;
  toDate: string;
}
